// icons
import { FaUsers } from "react-icons/fa";
import { MdMeetingRoom } from "react-icons/md";
// types
import type { ReactElement } from "react";
// config
import { paths, PathsTitle } from "routes/paths";

type NavbarItemChildrenTypes = { title: string; path: string };
type NavbarItemItemsTypes = {
  title: string;
  icon?: ReactElement;
  path: string;
  children?: NavbarItemChildrenTypes[];
};
type NavbarItemTypes = {
  subheader?: string;
  items: NavbarItemItemsTypes[];
};
type NavbarConfigTypes = NavbarItemTypes[];

const ICONS = {
  user: <FaUsers />,
  meetingRoom: <MdMeetingRoom />,
};

const NavbarConfig: NavbarConfigTypes = [
  {
    subheader: "general v3.3.0",
    items: [
      {
        title: PathsTitle.users.root,
        path: paths.users.list,
        icon: ICONS.user,
        children: [{ title: PathsTitle.users.list, path: paths.users.list }],
      },
      {
        title: PathsTitle.meetingRoom,
        path: paths.meetingRoom,
        icon: ICONS.meetingRoom,
      },
    ],
  },
];

export type {
  NavbarItemChildrenTypes,
  NavbarItemItemsTypes,
  NavbarItemTypes,
  NavbarConfigTypes,
};
export { NavbarConfig };
